import { render } from "./ProjectSettingsModal.vue?vue&type=template&id=2b11d778&scoped=true"
import script from "./ProjectSettingsModal.vue?vue&type=script&lang=js"
export * from "./ProjectSettingsModal.vue?vue&type=script&lang=js"

import "./ProjectSettingsModal.vue?vue&type=style&index=0&id=2b11d778&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b11d778"]])

export default __exports__